import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-03/lesson-19/task-02";

const task: Slide = {
  titleHtml:
    "Assume a sampling rate of 44100 Hz. What is the minimum latency for</br>block lengths of 64, 128 and 256 samples?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
